import * as $$String from "bs-platform/lib/es6/string.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_string from "bs-platform/lib/es6/caml_string.js";

function equal(prim, prim$1) {
  return prim === prim$1;
}

function chop_prefix(s, prefix) {
  var prefix_l = prefix.length;
  var string_l = s.length;

  if (prefix_l > string_l) {
    return;
  } else {
    try {
      for (var i = 0, i_finish = prefix_l - 1 | 0; i <= i_finish; ++i) {
        if (Caml_string.get(s, i) !== Caml_string.get(prefix, i)) {
          Pervasives.failwith("chop_prefix");
        }
      }

      return $$String.sub(s, prefix_l, string_l - prefix_l | 0);
    } catch (exn) {
      return;
    }
  }
}

var make = $$String.make;
var init = $$String.init;
var copy = $$String.copy;
var sub = $$String.sub;
var fill = $$String.fill;
var blit = $$String.blit;
var concat = $$String.concat;
var iter = $$String.iter;
var iteri = $$String.iteri;
var map = $$String.map;
var mapi = $$String.mapi;
var trim = $$String.trim;
var escaped = $$String.escaped;
var index = $$String.index;
var index_opt = $$String.index_opt;
var rindex = $$String.rindex;
var rindex_opt = $$String.rindex_opt;
var index_from = $$String.index_from;
var index_from_opt = $$String.index_from_opt;
var rindex_from = $$String.rindex_from;
var rindex_from_opt = $$String.rindex_from_opt;
var contains = $$String.contains;
var contains_from = $$String.contains_from;
var rcontains_from = $$String.rcontains_from;
var uppercase = $$String.uppercase;
var lowercase = $$String.lowercase;
var capitalize = $$String.capitalize;
var uncapitalize = $$String.uncapitalize;
var uppercase_ascii = $$String.uppercase_ascii;
var lowercase_ascii = $$String.lowercase_ascii;
var capitalize_ascii = $$String.capitalize_ascii;
var uncapitalize_ascii = $$String.uncapitalize_ascii;
var compare = $$String.compare;
var split_on_char = $$String.split_on_char;
export { make, init, copy, sub, fill, blit, concat, iter, iteri, map, mapi, trim, escaped, index, index_opt, rindex, rindex_opt, index_from, index_from_opt, rindex_from, rindex_from_opt, contains, contains_from, rcontains_from, uppercase, lowercase, capitalize, uncapitalize, uppercase_ascii, lowercase_ascii, capitalize_ascii, uncapitalize_ascii, compare, split_on_char, equal, chop_prefix };
/* No side effect */